import React from 'react';

import { Box, Typography } from '@mui/material';
import { StepPanelHeader } from 'src/components';

import confirmEmailImage from 'src/assets/confirm-email.webp';
import confirmEmailImagePNG from 'src/assets/confirm-email.png';

export const ConfirmationEmailSent: React.FC<{ email: string }> = ({
  email,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <StepPanelHeader
        srcSetPng={confirmEmailImagePNG}
        srcSetWebp={confirmEmailImage}
        alt="Confirm email"
        imageWidth={{ xs: 57, sm: 90, xxl: 100 }}
        sx={{ mb: 3 }}
      >
        Please check your inbox
      </StepPanelHeader>

      <Typography variant="body1" textAlign="center" mb={3}>
        We’ve sent you an email confirmation.
      </Typography>
      <Typography variant="body1" textAlign="center" sx={{ mb: 3 }}>
        Click on the link in that email <br /> to confirm this is you.
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        {email}
      </Typography>
    </Box>
  );
};
